import { 
    LOGINREQUEST, LOGINSUCCESS, LOGINFAILURE,
    GETINVENTORYREQUEST, GETINVENTORYSUCCESS, GETINVENTORYFAILURE,
    GETREPORTREQUEST, GETREPORTSUCCESS, GETREPORTFAILURE,
    GETFASTAGREQUEST, GETFASTAGSUCCESS, GETFASTAGFAILURE,
    GETAGENTSREQUEST, GETAGENTSSUCCESS, GETAGENTSFAILURE,
    GETAGENTSNAMESREQUEST, GETAGENTSNAMESSUCCESS, GETAGENTSNAMESFAILURE,
    GETINVENTORYDISTRIBUTORREQUEST, GETINVENTORYDISTRIBUTORSUCCESS, GETINVENTORYDISTRIBUTORFAILURE,
    GETDISTRIBUTORREQUEST, GETDISTRIBUTORSUCCESS, GETDISTRIBUTORFAILURE,
    GETDISTRIBUTORNAMESREQUEST, GETDISTRIBUTORNAMESSUCCESS, GETDISTRIBUTORNAMESFAILURE,
    GETINVENTORYAGENTREQUEST, GETINVENTORYAGENTSUCCESS, GETINVENTORYAGENTFAILURE,
    GETSTATEREQUEST, GETSTATESUCCESS, GETSTATEFAILURE,
    GETCITYREQUEST, GETCITYSUCCESS, GETCITYFAILURE,
    SENDOTPREQUEST, SENDOTPSUCCESS, SENDOTPFAILURE,
    CHANGEPASSWORDREQUEST, CHANGEPASSWORDSUCCESS, CHANGEPASSWORDFAILURE,
    EDITDISTRIBUTORREQUEST, EDITDISTRIBUTORSUCCESS, EDITDISTRIBUTORFAILURE,
    GETMASTERFASTAGREQUEST, GETMASTERFASTAGSUCCESS, GETMASTERFASTAGFAILURE,
    GETALLAGENTSNAMESREQUEST, GETALLAGENTSNAMESSUCCESS, GETALLAGENTSNAMESFAILURE,
    GETINVENTORYSUMMARYREQUEST, GETINVENTORYSUMMARYSUCCESS, GETINVENTORYSUMMARYFAILURE,
    CREATEDISTRIBUTORBULKREQUEST, CREATEDISTRIBUTORBULKSUCCESS, CREATEDISTRIBUTORBULKFAILURE,
    CREATEAGENTBULKREQUEST, CREATEAGENTBULKSUCCESS, CREATEAGENTBULKFAILURE,
    GETDISTRIBUTORSUMMARYREQUEST, GETDISTRIBUTORSUMMARYSUCCESS, GETDISTRIBUTORSUMMARYFAILURE,
    GETDISTRIBUTORAGENTSUMMARYREQUEST, GETDISTRIBUTORAGENTSUMMARYSUCCESS, GETDISTRIBUTORAGENTSUMMARYFAILURE,
    GETAGENTSUMMARYREQUEST, GETAGENTSUMMARYSUCCESS, GETAGENTSUMMARYFAILURE,
    GETDISTRIBUTORREQUESTREQUEST, GETDISTRIBUTORREQUESTSUCCESS, GETDISTRIBUTORREQUESTFAILURE,
    ASSIGNAGENTEXCELREQUEST, ASSIGNAGENTEXCELSUCCESS, ASSIGNAGENTEXCELFAILURE,
    GETALLFASTAGAGENTREQUESTREQUEST, GETALLFASTAGAGENTREQUESTSUCCESS, GETALLFASTAGAGENTREQUESTFAILURE,
    GETAGENTFASTAGREQUEST, GETAGENTFASTAGSUCCESS, GETAGENTFASTAGFAILURE,
    UPDATEAGENTREQUESTSTATUSREQUEST, UPDATEAGENTREQUESTSTATUSSUCCESS, UPDATEAGENTREQUESTSTATUSFAILURE,
    DENIEDREQUESTSTATUSREQUEST, DENIEDREQUESTSTATUSSUCCESS, DENIEDREQUESTSTATUSFAILURE,
    ASSIGNDISTRIBUTOREXCELREQUEST, ASSIGNDISTRIBUTOREXCELSUCCESS, ASSIGNDISTRIBUTOREXCELFAILURE,
    GET_AGENTS_DISTRIBUTOR_WISE_REQUEST, GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS, GET_AGENTS_DISTRIBUTOR_WISE_FAILURE
} from "./actionTypes";

const INITIAL_STATE = {
  activeRequests: 0,
  loading: false
};

const LoadingReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  // Check if it's a REQUEST action
  if (type.endsWith('REQUEST')) {
    const newCount = state.activeRequests + 1;
    return {
      ...state,
      activeRequests: newCount,
      loading: newCount > 0
    };
  }

  // Check if it's a SUCCESS or FAILURE action
  if (type.endsWith('SUCCESS') || type.endsWith('FAILURE')) {
    const newCount = Math.max(0, state.activeRequests - 1);
    return {
      ...state,
      activeRequests: newCount,
      loading: newCount > 0
    };
  }

  return state;
};

export default LoadingReducer;
